export enum ButtonType {
    BUTTON = 'button',
    SUBMIT = 'submit'
  }